import { createRef } from "react";
import { NavLink } from "react-router-dom";
import Scrollspy from 'react-scrollspy'

const ScenesList = ({ scenes, filmId }) => {

  const linkRefs = scenes.reduce((acc, value) => {
    acc[value.id] = createRef();
    return acc;
  }, {});

  let nameElement;
  const scrollSpyOnEvent = (e) => {
    if (!e) {
      return;
    }

    //nameElement?.scrollTo(0, linkRefs[e.id].current.offsetTop - 130);
  }

  return (
    <aside className="menu">
      <p className="menu-label">Breakdown</p>
      <ul className="menu-list">
        <NavLink
          to={`/films/${filmId}/breakdown/overview`}
          activeClassName="is-active"
          isActive={(match, location) => {
            return location.pathname.startsWith(
              `/films/${filmId}/breakdown/overview`
            );
          }}>
          Overview
        </NavLink>
        <hr />
      </ul>
      <ul className="breakdown-scene-nav">
        {(scenes || []).map((scene, idx) => {
          return (
            <li key={idx} className="menu-list">
              <NavLink
                to={`/films/${filmId}/breakdown/scenes/${scene.id}`}
                activeClassName="is-active"
                title={scene.number + ". " + scene.settingName}
                isActive={(match, location) => {
                  return location.pathname.startsWith(
                    `/films/${filmId}/breakdown/scenes/${scene.id}`
                  );
                }}>
                {scene.number}. {scene.settingName}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default ScenesList;
